//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core';

import type {QuickReply} from '../../../../../../../../entities';
import CustomButton from '../../../../../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../../../../../assets/styles/colors';
import {useLocalQuickReplies} from '../../../../../../quick-replies/utils';
import InlineLoader from '../../../../../../../../elements/LoadingSpinner/InlineLoader';
import {useEffect} from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    background: 'white',
    borderRadius: '.8rem .8rem 0 0',
    boxShadow: 'rgba(17, 12, 46, 0.1) 0px -24px 32px 0px',
    overflow: 'hidden',
    borderBottom: `1px solid ${colors.grey200}`,
    padding: '.5rem .75rem 0',
    maxHeight: '350px',
    overflowY: 'auto',
  },
  replyButton: {
    padding: '.75rem',
    width: '100%',
    textAlign: 'left',
    fontSize: '.8rem',
    borderBottom: `1px solid ${colors.grey200}`,
    borderRadius: 0,
    justifyContent: 'flex-start',
    '&:hover': {
      backgroundColor: colors.grey100,
      color: colors.primary,
    },

    '&:last-child': {
      borderBottom: 'none',
    },
  },
}));

type Props = {
  onSelectReply: (reply: QuickReply) => void,
  searchValue?: string,
};

export default function QuickRepliesSection(props: Props) {
  const {onSelectReply, searchValue} = props;

  const classes = useStyles();

  const {loading, quickReplies, searchQuickReplies} = useLocalQuickReplies();

  useEffect(() => {
    if (searchValue) {
      searchQuickReplies(searchValue);
    } else {
      searchQuickReplies('');
    }
  }, [searchQuickReplies, searchValue]);

  return (
    <aside className={classes.root}>
      {quickReplies.map(reply => (
        <CustomButton
          key={reply.id}
          className={classes.replyButton}
          variant="text"
          color="default"
          onClick={() => onSelectReply(reply)}
        >
          {reply.displayName}
        </CustomButton>
      ))}

      <InlineLoader loading={loading} />

      {quickReplies.length === 0 && !loading && (
        <CustomButton
          className={classes.replyButton}
          variant="text"
          color="default"
          to="/chat/quick-replies"
        >
          Crea una respuesta rápida
        </CustomButton>
      )}
    </aside>
  );
}
